(function() {
  
  const Backbone = require('backbone');

  var Domain = Backbone.Model.extend({

    urlRoot: '/api/domains'
  
  });
  

  module.exports = Domain;
  
})();
